import { formFieldFactory } from '@dagens/frontend-forms';
import { useTranslation } from '@dagens/frontend-i18n';
import { DeliveryFormValues } from '.';

const { Field, Input } = formFieldFactory<DeliveryFormValues>();

export const CustomerDeliveryInstructions = () => {
  const { t } = useTranslation();
  return (
    <Field
      to="deliveryInstructions"
      label={t('producer:EditCustomerDeliveryInstructions')}
      helpText={t('producer:EditCustomerDeliveryInstructionsDescription')}
    >
      <Input name="deliveryInstructions" />
    </Field>
  );
};
